import { useState } from 'react'

export default function Component() {
  const [selectedRole, setSelectedRole] = useState(null)
  const [selectedShift, setSelectedShift] = useState(null)

  return (
    <div className="min-h-screen bg-amber-50 py-6 flex flex-col justify-center sm:py-12">
      <div className="relative py-3 sm:max-w-xl sm:mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-amber-600 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
        <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
          <div className="max-w-md mx-auto">
            <div className="flex items-center space-x-5">
              <img
                src="https://shorturl.at/StLVP"
                alt="Employee"
                className="h-24 w-24 rounded-full ring-4 ring-amber-400"
              />
              <div>
                <h1 className="text-2xl font-semibold text-gray-900">John Doe</h1>
                <p className="text-gray-500">Employee ID: EMP001</p>
              </div>
            </div>

            <div className="divide-y divide-gray-200">
              <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                <h2 className="text-xl font-bold text-gray-900">Select Your Role</h2>
                <div className="flex space-x-4">
                  <button
                    className={`px-4 py-2 rounded-md ${
                      selectedRole === 'waiter'
                        ? 'bg-amber-500 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-amber-100'
                    }`}
                    onClick={() => setSelectedRole('waiter')}
                  >
                    Waiter
                  </button>
                  <button
                    className={`px-4 py-2 rounded-md ${
                      selectedRole === 'chef'
                        ? 'bg-amber-500 text-white'
                        : 'bg-gray-200 text-gray-700 hover:bg-amber-100'
                    }`}
                    onClick={() => setSelectedRole('chef')}
                  >
                    Chef
                  </button>
                </div>
              </div>

              {selectedRole && (
                <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                  <h2 className="text-xl font-bold text-gray-900">Select Your Shift</h2>
                  <div className="flex space-x-4">
                    <button
                      className={`px-4 py-2 rounded-md ${
                        selectedShift === '5am-2pm'
                          ? 'bg-amber-500 text-white hover:bg-amber-400'
                          : 'bg-gray-200 text-gray-700 hover:bg-amber-100'
                      }`}
                      onClick={() => setSelectedShift('5am-2pm')}
                    >
                      Morning
                    </button>
                    <button
                      className={`px-4 py-2 rounded-md ${
                        selectedShift === '2pm-1am'
                          ? 'bg-amber-500 text-white hover:bg-amber-400'
                          : 'bg-gray-200 text-gray-700 hover:bg-amber-100'
                      }`}
                      onClick={() => setSelectedShift('2pm-1am')}
                    >
                      Evening
                    </button>
                    <button
                      className={`px-4 py-2 rounded-md ${
                        selectedShift === '9pm-1am'
                          ? 'bg-amber-500 text-white hover:bg-amber-400'
                          : 'bg-gray-200 text-gray-700 hover:bg-amber-100'
                      }`}
                      onClick={() => setSelectedShift('9pm-1am')}
                    >
                      Night
                    </button>
                  </div>
                </div>
              )}

              {selectedRole && selectedShift && (
                <div className="pt-8 text-base leading-6 text-gray-700 sm:text-lg sm:leading-7">
                  <p className="font-semibold">
                    You have selected: {selectedRole} - {selectedShift} shift
                  </p>
                  <div className="flex justify-center mt-3">
                    <button
                      type="submit"
                      className="py-2 px-4 w-auto border border-transparent text-sm font-medium rounded-md text-white bg-gradient-to-r from-amber-400 to-amber-600 hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
